<template>
    <div class="help">
        <h2>ヘルプ</h2>
            ビル・ジェームズの提唱した「類似性スコア」の高い選手を検索するwebアプリです。<br>
            計算方法については各自ググってください。<br><br>
            <b>選手名を入力</b>ボックスに実在する選手の名前を入力して虫眼鏡を押すとその選手の成績を代入します。<br>上の<b>ランダム</b>を押すと選手をランダムで選択して入力します。<br>
            <br>
            成績を入力したら<b>類似選手検索</b>ボタンを押してみましょう。<br>
            その成績と似ている選手が表示されるはずです（ただし、スコアが高い選手が少なすぎると誰も引っかかりません）。<br>
            検索結果から選手名をクリックするとその選手の成績を上のフォームに代入します。<br>
    </div>
</template>
<script>

export default {
  name: 'HelpPage'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/help.vue